export const getRootPath = path => {
  return '/' + path.split('/')[1]
}



// WEBPACK FOOTER //
// ./src/utils/index.js